import { render, staticRenderFns } from "./PassoOutrasOpcoes.vue?vue&type=template&id=aa0df600&"
import script from "./PassoOutrasOpcoes.vue?vue&type=script&lang=js&"
export * from "./PassoOutrasOpcoes.vue?vue&type=script&lang=js&"
import style0 from "./PassoOutrasOpcoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports